import { SxProps } from '@mui/material/styles';
import MuiCircularProgress, {
  CircularProgressProps,
} from '@mui/material/CircularProgress';
import { FC } from 'react';
import { Box } from 'components/base/layout/Box';

interface ICircularProgress extends CircularProgressProps {
  containerProps?: SxProps;
}

export const CircularProgress: FC<ICircularProgress> = ({
  containerProps,
  ...rest
}) => {
  if (containerProps) {
    return (
      <Box
        sx={{
          ...containerProps,
        }}
      >
        <MuiCircularProgress {...rest} />
      </Box>
    );
  }

  return <MuiCircularProgress {...rest} />;
};
